"use client";
// import {} from "@/app/_helpers/helperFunctions";

import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  items: [],
  cashReceived: 0,
  change: 0,
  totalCartCost: 0,
  totalGrossSales: 0,
  customer: "",
  cart: [],
  openTransaction: false,
  deliveryCharge: 0,
  totalDiscount: 0,
  customerType: null, // consumer / reseller
  transactionType: null, // pick-up / delivery
  online: false,
  onlineOrderId: null,
  orderCode: "",
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    addItem(state, action) {
      const {
        branch_product_id: id,
        products,
        selling_price: sellingPrice,
        stock_quantity: stockQuantity,
        online,
      } = action.payload;

      const productName = products.product_name;

      if (state.cart.some((item) => item.id === id)) {
        return;
      } else {
        const cartItem = {
          id,
          productName,
          sellingPrice,
          quantity: 1,
          discount: 0,
          totalAmount: sellingPrice,
          stockQuantity,
          online,
        };

        state.items = [...state.items, action.payload];
        state.cart = [...state.cart, cartItem];
        state.totalCartCost =
          state.cart.reduce(
            (accum, current) => accum + current.totalAmount,
            0
          ) + state.deliveryCharge;

        state.totalGrossSales = state.cart.reduce(
          (accum, current) => accum + current.sellingPrice * current.quantity,
          0
        );
      }
    },

    addItemFromOnline(state, action) {
      const {
        branch_product_id: id,
        productName,
        selling_price: sellingPrice,
        stock_quantity: stockQuantity,
        online,
        quantity,
        discount,
      } = action.payload;

      const cartItem = {
        id,
        productName,
        sellingPrice,
        quantity,
        discount,
        totalAmount: sellingPrice,
        stockQuantity,
        online,
      };

      state.items = [...state.items, action.payload];
      state.cart = [...state.cart, cartItem];
      state.totalCartCost =
        state.cart.reduce((accum, current) => accum + current.totalAmount, 0) +
        state.deliveryCharge;

      state.totalGrossSales = state.cart.reduce(
        (accum, current) => accum + current.sellingPrice * current.quantity,
        0
      );
    },

    modifyCartItem(state, action) {
      // Filter out item in state
      const { id, quantity, discount } = action.payload;
      state.cart = state.cart.map((item) => {
        return item.id === id
          ? {
              ...item,
              quantity: quantity ?? item.quantity,
              discount: discount ?? item.discount,
              totalAmount:
                (item.sellingPrice - discount ?? 0) *
                (quantity ?? item.quantity),
            }
          : item;
      });

      state.totalCartCost =
        state.cart.reduce((accum, current) => accum + current.totalAmount, 0) +
        state.deliveryCharge;

      state.totalDiscount = state.cart.reduce(
        (accum, current) => accum + current.quantity * current.discount,
        0
      );

      state.totalGrossSales = state.cart.reduce(
        (accum, current) => accum + current.sellingPrice * current.quantity,
        0
      );
    },

    setOrderType(state, action) {
      state.online = action.payload.online;
      state.onlineOrderId = action.payload.id;
      state.orderCode = action.payload.orderCode;
    },

    removeCartItem(state, action) {
      const id = action.payload;
      state.cart = state.cart.filter((cart) => cart.id !== id);
      state.totalCartCost =
        state.cart.reduce((accum, current) => accum + current.totalAmount, 0) +
        state.deliveryCharge;

      state.totalDiscount = state.cart.reduce(
        (accum, current) => accum + current.quantity * current.discount,
        0
      );

      state.totalGrossSales = state.cart.reduce(
        (accum, current) => accum + current.sellingPrice * current.quantity,
        0
      );
    },

    removeItems(state, action) {
      state.items = [];
      state.cart = [];
      state.totalCartCost =
        state.cart.reduce((accum, current) => accum + current.totalAmount, 0) +
        state.deliveryCharge;

      state.totalDiscount = state.cart.reduce(
        (accum, current) => accum + current.quantity * current.discount,
        0
      );

      state.totalGrossSales = state.cart.reduce(
        (accum, current) => accum + current.sellingPrice * current.quantity,
        0
      );
    },

    addCash(state, action) {
      state.cashReceived = action.payload.cash;
      state.change = action.payload.changeAmount;
    },

    setTransactionStatus(state, action) {
      state.openTransaction = action.payload;
    },

    resetTransaction(state, action) {
      return initialState;
    },

    setDeliveryCharge(state, action) {
      state.deliveryCharge = action.payload;
      state.totalCartCost =
        state.cart.reduce((accum, current) => accum + current.totalAmount, 0) +
        state.deliveryCharge;
    },

    setCustomerTransactionType(state, action) {
      state.customerType = action.payload.customerType;
      state.transactionType = action.payload.transactionType;
    },
  },
});

export const {
  addItem,
  removeItems,
  modifyCartItem,
  removeCartItem,
  addCash,
  setTransactionStatus,
  resetTransaction,
  setDeliveryCharge,
  setCustomerTransactionType,
  setOrderType,
  addItemFromOnline,
} = transactionSlice.actions;

export default transactionSlice.reducer;
